import { render, staticRenderFns } from "./ResetPasswordComponent.vue?vue&type=template&id=2051ac7a&scoped=true&"
import script from "./ResetPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordComponent.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordComponent.vue?vue&type=style&index=0&id=2051ac7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2051ac7a",
  null
  
)

export default component.exports